import React from 'react'

import { useHistory } from 'react-router-dom'

import { Box, Button } from '@material-ui/core'

import { Container, Page } from 'components'

import { ChangesManagementForm } from './components'

import { routes } from 'Routes'

const ChangesManagementNew = () => {
  const history = useHistory()

  return (
    <Page title="Nova Gestão de Mudanças">
      <Container maxWidth={false}>
        <ChangesManagementForm />
        <Box ml={2} mt={2} display="flex" justifyContent="flex-end">
          <Box pr={1}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => history.push(routes.changesManagement.all)}
            >
              Cancelar
            </Button>
          </Box>
          <Box>
            <Button
              form="changes-management-form"
              type="submit"
              color="primary"
              variant="contained"
            >
              Criar
            </Button>
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default ChangesManagementNew
